module.exports = __webpack_public_path__ + "img/repositorio_unico_icon.64eea1c7.svg";